import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { GENERATE_SUMMARY,GET_SUMMARIES } from "./actionTypes";
import { generateSummaryFailure, generateSummarySuccess,setSummaries,getSummaryFailure } from "./actions";
import { setMessageAi } from "../operator/actions";

import axios from "axios";

function* generateSummarization({ payload: { conversationId, messageId } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/${conversationId}/summary`,
      { messageId }
    );

    if (response.status === 200) {
      yield put(generateSummarySuccess());
      yield put(setMessageAi({ summary: response.data.summary, summaryKeywords: response.data.keywords }, messageId, conversationId));
      yield put({ type: GET_SUMMARIES, payload: { conversationId } });
    } else {
      throw response.data;
    }
  } catch (error) {
    const message = 'Summary not currently available';
    yield put(generateSummaryFailure(message));
  }
}

function* getSummaries({ payload: { conversationId } }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/${conversationId}/summaries`
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setSummaries(response.data));
    } else {
      throw response.data;
    }
  }   catch (error) {
    const message = 'Summary not currently available';
    yield put(getSummaryFailure(message));
  }
}
export function* watchGenerateSummarization() {
  yield takeEvery(GENERATE_SUMMARY, generateSummarization);
}
export function* watchGetSummaries() {
  yield takeEvery(GET_SUMMARIES, getSummaries);
}

function* authSaga() {
  yield all([
    fork(watchGenerateSummarization),
    fork(watchGetSummaries),
  ]);
}
export default authSaga;
